const getMapproxyAppUrl = (prefix, projectId) => {
  if (prefix && projectId) {
    return `/mapproxy/apps/${prefix}/${projectId}`;
  } else {
    return '';
  }
};

export default getMapproxyAppUrl;
